import type { IconSvgObject } from './types';

const HousePlusIcon: IconSvgObject = [
  ["path", { d: "M17.9942 15V22M21.5 18.4942L14.5 18.4942", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 21H9.5C6.20017 21 4.55025 21 3.52513 19.9749C2.5 18.9497 2.5 17.2998 2.5 14L2.5 11.4896C2.5 9.80834 2.5 8.96773 2.8559 8.24005C3.21179 7.51237 3.87533 6.99628 5.20241 5.96411L7.20242 4.40855C9.26689 2.80285 10.2991 2 11.5 2C12.7009 2 13.7331 2.80285 15.7976 4.40855L17.7976 5.96411C19.1247 6.99628 19.7882 7.51237 20.1441 8.24005C20.5 8.96773 20.5 9.80834 20.5 11.4896V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HousePlusIcon;
